export default "__VITE_ASSET__CERD2YWh__"